module.exports = __webpack_public_path__ + "img/icon-price-img.f7c45c26.png";